import React, { useState } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import ManageUsers from './ManageUsers';
import ManageHolidays from './ManageHolidays';
import ApproveRequests from './ApproveRequests';
import ManageAssignments from './ManageAssignments';
import DataManagement from './DataManagement';
import ActivityLog from './ActivityLog';
import { UsersIcon, CalendarIcon, CheckIcon, ClipboardIcon, DatabaseIcon, ActivityIcon } from 'lucide-react';
const AdminSettings = () => {
  const location = useLocation();
  return <div className="space-y-6" data-id="element-57">
      <div className="bg-white rounded-lg shadow-md p-6" data-id="element-58">
        <h2 className="text-2xl font-bold mb-6 text-gray-800" data-id="element-59">
          Admin Settings
        </h2>
        <div className="flex border-b overflow-x-auto" data-id="element-60">
          <Link to="/admin" className={`px-4 py-2 border-b-2 text-sm font-medium whitespace-nowrap ${location.pathname === '/admin' ? 'text-gray-500 hover:text-gray-700 hover:border-gray-300' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} style={location.pathname === '/admin' ? {
          borderColor: '#4772B0',
          color: '#4772B0'
        } : {}} data-id="element-61">
            <div className="flex items-center" data-id="element-62">
              <UsersIcon size={16} className="mr-2" data-id="element-63" />
              Manage APNs
            </div>
          </Link>
          <Link to="/admin/holidays" className={`px-4 py-2 border-b-2 text-sm font-medium whitespace-nowrap ${location.pathname === '/admin/holidays' ? 'text-gray-500 hover:text-gray-700 hover:border-gray-300' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} style={location.pathname === '/admin/holidays' ? {
          borderColor: '#4772B0',
          color: '#4772B0'
        } : {}} data-id="element-64">
            <div className="flex items-center" data-id="element-65">
              <CalendarIcon size={16} className="mr-2" data-id="element-66" />
              Manage Holidays
            </div>
          </Link>
          <Link to="/admin/requests" className={`px-4 py-2 border-b-2 text-sm font-medium whitespace-nowrap ${location.pathname === '/admin/requests' ? 'text-gray-500 hover:text-gray-700 hover:border-gray-300' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} style={location.pathname === '/admin/requests' ? {
          borderColor: '#4772B0',
          color: '#4772B0'
        } : {}} data-id="element-67">
            <div className="flex items-center" data-id="element-68">
              <CheckIcon size={16} className="mr-2" data-id="element-69" />
              Approve Requests
            </div>
          </Link>
          <Link to="/admin/assignments" className={`px-4 py-2 border-b-2 text-sm font-medium whitespace-nowrap ${location.pathname === '/admin/assignments' ? 'text-gray-500 hover:text-gray-700 hover:border-gray-300' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} style={location.pathname === '/admin/assignments' ? {
          borderColor: '#4772B0',
          color: '#4772B0'
        } : {}} data-id="element-70">
            <div className="flex items-center" data-id="element-71">
              <ClipboardIcon size={16} className="mr-2" data-id="element-72" />
              Manage Assignments
            </div>
          </Link>
          <Link to="/admin/activity" className={`px-4 py-2 border-b-2 text-sm font-medium whitespace-nowrap ${location.pathname === '/admin/activity' ? 'text-gray-500 hover:text-gray-700 hover:border-gray-300' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} style={location.pathname === '/admin/activity' ? {
          borderColor: '#4772B0',
          color: '#4772B0'
        } : {}} data-id="element-73">
            <div className="flex items-center" data-id="element-74">
              <ActivityIcon size={16} className="mr-2" data-id="element-75" />
              Activity Log
            </div>
          </Link>
          <Link to="/admin/data" className={`px-4 py-2 border-b-2 text-sm font-medium whitespace-nowrap ${location.pathname === '/admin/data' ? 'text-gray-500 hover:text-gray-700 hover:border-gray-300' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} style={location.pathname === '/admin/data' ? {
          borderColor: '#4772B0',
          color: '#4772B0'
        } : {}} data-id="element-76">
            <div className="flex items-center" data-id="element-77">
              <DatabaseIcon size={16} className="mr-2" data-id="element-78" />
              Data Management
            </div>
          </Link>
        </div>
        <div className="mt-6" data-id="element-79">
          <Routes data-id="element-80">
            <Route path="/" element={<ManageUsers data-id="element-82" />} data-id="element-81" />
            <Route path="/holidays" element={<ManageHolidays data-id="element-84" />} data-id="element-83" />
            <Route path="/requests" element={<ApproveRequests data-id="element-86" />} data-id="element-85" />
            <Route path="/assignments" element={<ManageAssignments data-id="element-88" />} data-id="element-87" />
            <Route path="/activity" element={<ActivityLog data-id="element-90" />} data-id="element-89" />
            <Route path="/data" element={<DataManagement data-id="element-92" />} data-id="element-91" />
          </Routes>
        </div>
      </div>
    </div>;
};
export default AdminSettings;